(() => {
  'use strict';
  if (window.fmdEnquiryInitialised) return;
  window.fmdEnquiryInitialised = true;
  const dialog = document.getElementById('FmdEnquiryDialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const form = dialog.querySelector('form');
  const email = dialog.querySelector('[name="contact[email]"]');
  const body = dialog.querySelector('[data-fmd-enquiry-body]');
  const product = dialog.querySelector('[data-fmd-enquiry-product]');
  const fields = dialog.querySelector('[data-fmd-enquiry-fields]');
  const fallback = dialog.querySelector('[data-fmd-enquiry-email-link]');
  let opener = null;

  const close = () => dialog.close();
  dialog.querySelector('[data-fmd-enquiry-close]').addEventListener('click', close);
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('close', () => {
    email.value = '';
    if (opener?.isConnected) opener.focus();
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-fmd-enquire]');
    if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    opener = trigger;
    const data = trigger.dataset;
    const variant = data.variantTitle && data.variantTitle !== 'Default Title' ? ` — ${data.variantTitle}` : '';
    product.textContent = `${data.productTitle}${variant}`;
    body.value = `Please check availability and reply to the email provided.\nProduct: ${data.productTitle}\nVariant: ${data.variantTitle || 'Default'}\nSKU: ${data.sku || 'Not supplied'}\nVariant ID: ${data.variantId || 'Not supplied'}\nProduct URL: ${data.productUrl}\nThis is an enquiry only, not an order or reservation.`;
    fallback.href = trigger.href;
    const returnUrl = new URL(location.pathname, location.origin);
    if (location.pathname.includes('/products/') && data.variantId) returnUrl.searchParams.set('variant', data.variantId);
    // Shopify follows return_to after accepting the native contact submission.
    // Retain its success marker so Liquid can render the result on this page.
    returnUrl.searchParams.set('contact_posted', 'true');
    const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
    if (previewTheme && /^\d+$/.test(previewTheme)) returnUrl.searchParams.set('preview_theme_id', previewTheme);
    returnUrl.hash = 'FmdEnquiryForm';
    dialog.querySelector('[data-fmd-enquiry-return]').value = `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`;
    dialog.querySelectorAll('[data-fmd-enquiry-success], [data-fmd-enquiry-errors]').forEach(el => { el.hidden = true; });
    fields.hidden = false;
    dialog.showModal();
    email.focus();
  });

  form.addEventListener('submit', (event) => {
    // Keep Shopify's native submission and spam protection. Never fake a success.
    if (!body.value.trim()) {
      event.preventDefault();
      email.setCustomValidity('Close this form and select Notify me on the product you are interested in.');
      email.reportValidity();
    }
  });
  email.addEventListener('input', () => email.setCustomValidity(''));

  // Only this form's native result may reopen the enquiry dialog.
  if (location.hash === '#FmdEnquiryForm') {
    const response = dialog.querySelector('[data-fmd-enquiry-success], [data-fmd-enquiry-errors]');
    if (response) {
      dialog.showModal();
      response.focus();
    }
  }
})();
